
import React from "react";
import { TypesAndLayouts } from "../config/fieldsConfig";
import { Icon } from "../styles/icons" ;

function renderText( isView, value, onChange ) {
  return isView ? <span>{value || ""}</span> : <input type="text" value={value || ""} onChange={e => onChange(e.target.value)} />;
}

function renderTextarea( isView, value, onChange ) {
  return isView ? <span>{value || ""}</span> : <textarea value={value || ""} onChange={e => onChange(e.target.value)} />;
}

function renderDate( isView, value, onChange ) {
  return isView ? <span>{value || ""}</span> : <input type="date" value={value || ""} onChange={e => onChange(e.target.value)} />;
}

function renderUrl ( isView, url, onChange ) { // simple URl - we handle DynamicList elsewhere
  return isView ? (
    <a href={url} target="_blank" rel="noopener noreferrer">{url}</a> 
  ) : (
    <input type="url" value={url || ""} onChange={e => onChange(e.target.value)} /> 
  ) ;
}

function renderSelect ( isView, value, options, onChange ) {
  return isView ? <span>{value}</span> : (
    <select value={value || ""} onChange={e => onChange(e.target.value)}>
      {(options || []).map(opt => <option key={opt} value={opt}>{opt}</option>)}
    </select>
  );
}

function renderBoolean ( isView, value, onChange ) {
  return isView ? <span>{value ? "Yes" : "No"}</span> : <input type="checkbox" checked={value} onChange={e => onChange(e.target.checked)} />;
}

function renderDynamicListUrlEntry ( mode, index, item, onItemChange, onRemove ) {
   return ( mode === "view" ) ? ( 
     <div key={index} className="list-item-row">
       <a href={item.url} target="_blank" rel="noopener noreferrer"> {item.displayText || item.url} </a>
     </div>
    ) : (
      <div key={index} className="list-item-row">
        <input
          type="text"
          placeholder="Label"
          value={item.displayText || ""}
          onChange={(e) => onItemChange(index, "displayText", e.target.value)}
        />
        <input
          type="url"
          placeholder="URL"
          value={item.url || ""}
          onChange={(e) => onItemChange(index, "url", e.target.value)}
        />
        <button type="button" onClick={() => onRemove(index)}>{Icon("deleteRecord")}</button>
      </div>
    ) ;
}

function renderDynamicListFileEntry ( mode, index, item, onItemChange, onViewFile, onRemove ) {
  return (mode === "view" ) ? (
    <div key={index} className="list-item-row">
      <div className="file-view-label">{item.displayText}</div>
      <button type="button" className="icon-button" title="View File" onClick={() => onViewFile(item.url)}>{Icon("viewRecord")}</button>
    </div>
  ) : (
    <div key={index} className="list-item-row">
      <input
        type="text"
        placeholder="Label"
        value={item.displayText || ""}
        onChange={(e) => onItemChange(index, "displayText", e.target.value)}
      />
      {!item.url ? (
        <input
          type="file"
          onChange={(e) => onItemChange(index, "file", e.target.files[0])}
        />
      ) : (
        <button type="button" className="icon-button" title="View File" onClick={() => onViewFile(item.url)}>{Icon("viewRecord")}</button>
      ) }
      <button type="button" className="icon-button" title="Delete Entry" onClick={() => onRemove(index)}>{Icon("deleteRecord")}</button>
    </div>
  ) ;
}



export function renderField({ field, value, mode, onChange, onAdd, onRemove, onItemChange, onViewFile }) {
  const layout = TypesAndLayouts[field.type] || "label-field";
  const isView = mode === "view";
  if (layout === "label-over-field" && !Array.isArray(value)) value = [];

  const renderDynamicListField = () => (
    <div className="form-row-wide-field">
      {value.map((item, index) => {
        if (field.type === "urlList") {
          return renderDynamicListUrlEntry( mode, index, item, onItemChange, onRemove ) ;
        } else if (field.type === "fileList") { 
          return renderDynamicListFileEntry( mode, index, item, onItemChange, onViewFile, onRemove ) ;
        } else {
          return null;
        }
      })}
    </div>
  );

  const renderInput = () => {
    switch (field.type) {
      case "text":
        return renderText( isView, value, onChange ) ;
      case "textarea":
        return renderTextarea( isView, value, onChange ) ;
      case "date":
        return renderDate ( isView, value, onChange ) ;
      case "url":
        return renderUrl( isView, value, onChange ) ;
      case "boolean":
        return renderBoolean( isView, value, onChange ) ;
      case "select":
        return renderSelect( isView, value, field.options, onChange ) ;
      case "urlList":
      case "fileList": // only return the Add button if not a view mode... Field rendered separately
        return isView ? <span /> : <button type="button" className="icon-button" title="Add Entry" onClick={onAdd}>{Icon("create")}</button> ;
      default:
        return <span>Unsupported field type: {field.type}</span>;
    }
  };

  
  return (
    <>
      <div className="form-row">
        <label>{field.label}</label>
        {renderInput()}
      </div>
      {layout === "label-over-field" && renderDynamicListField()}
    </>
  );
}
